module.exports = __webpack_public_path__ + "media/images/city_img/d_2-d419391e9e4b7c34221d88b11506601a.jpg";